import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { Observable } from 'rxjs';

const URL = 'https://app.inforida.com/api';
const tryUrl = 'https://tryit.inforida.com/api';

@Injectable({
  providedIn: 'root',
})
export class APIService {
  constructor(private http: HttpClient) {}

  submitDemo(data: any) {
    const toCall = `${URL}/demo/addDemoRequest`;
    return this.http.post(toCall, data);
  }

  getSchoolBySlug(slug) {
    return this.http.get(`${URL}/school/getBySlug/${slug}`);
  }

  getEventsAndNotices(schoolId) {
    return this.http.get(`${URL}/school/getEventsAndNotices/${schoolId}`);
  }

  createAdmissionEnquiry(data: any) {
    const toCall = `${URL}/school/createAdmissionEnquiry`;
    return this.http.post(toCall, data);
  }

  createVisitEnquiry(data: any) {
    const toCall = `${URL}/school/createVisitEnquiry`;
    return this.http.post(toCall, data);
  }

  getClassBySchoolId(sId) {
    return this.http.get(`${URL}/class/getBySchoolId/${sId}`); // this can be tryIt
  }

  addStudent(data: any): Observable<any> {
    const studentUrl = `${URL}/students/v2/add`; // this can be tryIt
    return this.http.post(studentUrl, data);
  }

  recordSchoolPageVisit(data: any) {
    const toCall = `${URL}/school/recordSchoolPageVisit`;
    return this.http.post(toCall, data);
  }

  getBlob(url) {
    return this.http.get(url, { responseType: 'blob' });
  }

  getSchoolLogo() {
    return of([
      // {
      //   url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-01.png',
      // },
      // {
      //   url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-02.png',
      // },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-03.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-04.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-05.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-06.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-07.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-08.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-09.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-10.png',
      },
      // {
      //   url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-11.png',
      // },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-12.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-13.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-14.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-15.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-16.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-17.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-18.png',
      },
      // {
      //   url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-19.png',
      // },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-20.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-21.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-22.png',
      },
      // {
      //   url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-23.png',
      // },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-24.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-25.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-26.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-27.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-28.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-29.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-30.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-31.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-32.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-33.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-34.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-35.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-36.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-37.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-38.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-39.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-40.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-41.png',
      },
      // {
      //   url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-42.png',
      // },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-43.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-44.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-45.png',
      },
      {
        url: 'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/school-logo-46.png',
      },
    ]);
  }
}
